/**
 * 无效图片URL列表（需要被替换的图片）
 */
const INVALID_IMAGE_PATTERNS = [
  '83f89c28bad4321321c16fdd915c552a',
  'default_img.png',
  'default_error_img.jpg',
  'no_support_img.png',
  'blank.gif',
  'loading.gif',
  'transparent.png'
]

/**
 * 默认图片（logo.png）
 */
const DEFAULT_IMAGE = require('@/assets/images/logo.png')

/**
 * 检查图片URL是否有效
 * @param {string} url - 图片URL
 * @returns {boolean} - 是否有效
 */
export function isValidImageUrl(url) {
  if (!url) return false
  
  for (const pattern of INVALID_IMAGE_PATTERNS) {
    if (url.includes(pattern)) {
      return false
    }
  }
  
  return true
}

/**
 * 获取有效的图片URL（无效时返回默认图片）
 * @param {string} url - 原始图片URL
 * @returns {string} - 有效的图片URL
 */
export function getValidImageUrl(url) {
  if (!url) return DEFAULT_IMAGE
  return isValidImageUrl(url) ? url : DEFAULT_IMAGE
}

/**
 * 图片加载错误处理
 * @param {Event} event - 错误事件
 */
export function handleImageError(event) {
  event.target.src = DEFAULT_IMAGE
}

export default {
  isValidImageUrl,
  getValidImageUrl,
  handleImageError,
  DEFAULT_IMAGE
}